<template>
	<main class="not-found">
		<div class="not-found__inner _cnt">
			<div class="not-found__title _h2">
				{{ $t("Unfortunately couldn't find the page") }}
			</div>
		</div>
	</main>
</template>
<script>
import { ButtonThemes } from '@/components/base/BaseButton.vue';

export default {
	name: 'PageNotFound',
	components: {},
	props: [],
	data: function () {
		return {
			ButtonThemes,
		};
	},
	methods: {},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.not-found {
	@include header-indent;
	@include adaptiveValue('padding-top', 60, 25);
	@include adaptiveValue('padding-bottom', 60, 25);
	position: relative;
	min-height: calc(100vh - 98px);
	@media (max-width: $md1) {
		min-height: calc(100vh - 70px);
	}
	@media (max-width: $md4) {
		min-height: calc(100vh - 50px);
	}
	display: flex;
	align-items: center;
	&::before {
		content: '';
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('@/assets/images/bg/vertical-bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-size: 100% 100%;
		z-index: -1;
	}
	&__inner {
		@media (min-width: $md5) {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__title {
		text-align: center;
		display: block;
		margin: 0 auto;
	}
}
</style>
